import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PieChartComponent } from './pie.component';

@NgModule({
  entryComponents: [
    PieChartComponent
  ],
  imports: [
    TranslateModule,

    NgxChartsModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule,
    FlexLayoutModule
  ],
  declarations: [
    PieChartComponent
  ],
  exports: [
    PieChartComponent
  ]
})
export class PieChartModule {}
